module.exports = __webpack_public_path__ + "img/footer_logo.9483e3f7.png";